import React, { forwardRef, ButtonHTMLAttributes } from "react";
import classNames from "classnames";

import { Slot } from "components/slot";
import { useBottomSheetContext } from "./bottomSheetContext";

export type TriggerProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  /** Merge props onto the child instead of rendering a <button>. */
  asChild?: boolean;
};

export const Trigger = forwardRef<HTMLButtonElement, TriggerProps>(
  ({ className, onClick, children, asChild = false, type, ...rest }, ref) => {
    const { open, setOpen } = useBottomSheetContext();
    const Comp = asChild ? Slot : "button";

    return (
      <Comp
        {...rest}
        ref={ref}
        type={asChild ? undefined : type || "button"}
        className={asChild ? className : classNames("ui-bottom-sheet-dialog-trigger", className)}
        aria-haspopup="dialog"
        aria-expanded={open}
        onClick={event => {
          onClick?.(event as React.MouseEvent<HTMLButtonElement>);
          if (event.defaultPrevented) {
            return;
          }
          setOpen(true, "trigger-press");
        }}
      >
        {children}
      </Comp>
    );
  },
);

Trigger.displayName = "BottomSheet.Trigger";
